import { useNavigate } from "react-router-dom";
import BackButton from "../../common/components/BackButton";
import useComponents from "../../common/hooks/pages/useComponents";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import Select from "react-select";
import { usePopup } from "../../common/contexts/PopupContext";

function IncidentForm() {
  const navigate = useNavigate();
  const { getIncidentStatusTypes, createIncident, BackfillIncident } =
    useIncidents();
  const { getComponents, getComponentStatusTypes } = useComponents();
  const [incidentStatus, setIncidentStatus] = useState([]);
  const [components, setComponents] = useState([]);
  const [componentstatus, setComponentstatus] = useState([]);
  const [backfill, setBackfill] = useState(true);
  const [notify, setNotify] = useState(false);
  const [componentarr, setComponentarr] = useState([]);

  const [name, setName] = useState("");
  const [incistatus, setIncistatus] = useState("");
  const [message, setMessage] = useState("");
  const [notification, setNotification] = useState(false);
  const [remainder, setRemainder] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [placeholder, setPlaceholder] = useState("Message");

  const { toast } = usePopup();

  const { mutate: createIncidentMutate } = useMutation({
    mutationFn: createIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const { mutate: BackfillIncidentMutate } = useMutation({
    mutationFn: BackfillIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const {
    mutate: getIncidentStatus,
    data,
    isLoading: isCreating,
  } = useMutation({
    mutationFn: getIncidentStatusTypes,
    onSuccess: (res) => {
      setIncidentStatus(res.data.incidentStatusTypes);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: get_Components,
    data: records,
    isLoading: isCreate,
  } = useMutation({
    mutationFn: getComponents,
    onSuccess: (res) => {
      setComponents(res.data.components);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: getComponentStatus,
    data: status,
    isLoading: isCreates,
  } = useMutation({
    mutationFn: getComponentStatusTypes,
    onSuccess: (res) => {
      setComponentstatus(res.data.componentStatusTypes);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  function checkedHandler(e) {
    if (e.target.checked) {
      setBackfill(false);
    } else {
      setBackfill(true);
    }
  }

  useEffect(() => {
    getIncidentStatus();
    get_Components();
    getComponentStatus();
  }, []);

  function incidentHandler(e) {
    setIncistatus(e._id);
    if (e.label === "Identified") {
      setMessage(
        "The issue has been identified and a fix is being implemented."
      );
    } else if (e.label === "Investigating") {
      setMessage("We are currently investigating this issue.");
    } else if (e.label === "Monitoring") {
      setMessage(
        "A fix has been implemented and we are monitoring the results."
      );
    } else if (e.label === "Resolved") {
      setMessage("This incident has been resolved.");
    }
  }

  const submitHandler = (e) => {
    e.preventDefault();
    let updatedMessage = message || placeholder;
    setMessage(updatedMessage);
    if (backfill) {
      createIncidentMutate({
        name: name,
        status: incistatus,
        message: message,
        components: componentarr,
        notification: notification,
        remainder: remainder,
      });
    } else {
      BackfillIncidentMutate({
        name: name,
        message: message,
        incidentDate: date,
        time: time,
      });
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Add Incident</div>
        <BackButton onClick={() => navigate("/view_incidents")}>
          Back to Incidents
        </BackButton>
      </div>
      <form className="space-y-6" onSubmit={submitHandler}>
        <div className={`my-4 }`}>
          <div className="pb-1 text-gray-800">Incident name</div>
          <input
            type="text"
            onChange={(e) => setName(e.target.value)}
            className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full 
        }`}
            required
          />
          <div className={`my-4 }`}>
            <input type="checkbox" onChange={checkedHandler} />
            <span className="pb-1 text-gray-800 incident_checkbox">
              Backfill an incident that happened in the past
            </span>
          </div>
          {backfill && (
            <div className="my-4">
              <div className="pb-1 text-gray-800">Incident status</div>
              <Select options={incidentStatus} onChange={incidentHandler} />
            </div>
          )}
          {backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Message</div>
              <textarea
                type="text"
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
                rows={4}
                cols={50}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
                defaultValue={message}
              />
            </div>
          )}
          {backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Components affected</div>
              <hr />
              {components?.map((record, i) => {
                return (
                  <AffectedItems
                    record={record}
                    options={componentstatus}
                    componentarr={componentarr}
                    setComponentarr={setComponentarr}
                  />
                );
              })}
            </div>
          )}
          {backfill && (
            <div className={`my-4 }`}>
              <hr />
              <br />
              <div className="pb-1 text-gray-800">Notifications</div>
            </div>
          )}
          {backfill && (
            <div className={`my-1 ${notify && "is-disabled"}`}>
              <input
                type="checkbox"
                onChange={(e) => setNotification(e.target.checked)}
              />
              <span className="pb- text-gray-800 incident_checkbox">
                Send Notifications
              </span>
            </div>
          )}
          {backfill && (
            <div className={`my-10 }`}>
              <div className="pb-1 text-gray-800">
                Long running incident reminders
              </div>
              <hr />
            </div>
          )}
          {backfill && (
            <div className={`my-1 }`}>
              <input
                type="checkbox"
                onChange={(e) => setRemainder(e.target.checked)}
              />
              <span className="pb- text-gray-800 incident_checkbox">
                Remind admins to update an incident
              </span>
              <div className={`my-4 incident_checkbox}`}>
                <span className="pb-1 text-gray-800 incident_checkbox">
                  * Send reminders to all admins after 3, 6, 12, and 24 hours.
                </span>
              </div>
            </div>
          )}
          {!backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">
                Incident date (GMT -5:30)
              </div>
              <input
                type="date"
                onChange={(e) => setDate(e.target.value)}
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/2`}
              />
              <input
                type="time"
                onChange={(e) => setTime(e.target.value)}
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/2`}
              />
            </div>
          )}
          {!backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Message</div>
              <textarea
                type="text"
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
                rows={4}
                cols={50}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
              />
            </div>
          )}
        </div>
        <div className={`my-16 !w-fit `}>
          <button
            type="submit"
            className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300
          }`}
          >
            Create an Incident
            <div className="flex justify-center items-center"></div>
          </button>
        </div>
      </form>
    </div>
  );
}

export default IncidentForm;

const AffectedItems = ({ record, options, setComponentarr, componentarr }) => {
  const [componentstatus, setComponentstatus] = useState(false);
  const [componentval, setComponentval] = useState("");
  const [statusval, setStatusval] = useState("");

  function onStatusHandler(e) {
    const index = componentarr.findIndex(
      (item) => item.component === componentval
    );
    if (index !== -1) {
      componentarr[index] = {
        component: componentval,
        status: e._id,
      };
    } else {
      componentarr.push({ component: componentval, status: e._id });
    }
  }

  function onChangeHandler(e) {
    setComponentstatus(e.target.checked);
    setComponentval(e.target.id);
  }
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="my-4" key={record._id}>
        <input
          name="affectedcomponents"
          checked={componentstatus}
          type="checkbox"
          id={record._id}
          onChange={onChangeHandler}
          value={statusval}
        />
        <span className="pb-1 text-gray-800 incident_checkbox">
          {record.name}
        </span>
      </div>
      {componentstatus && (
        <div class="col-md-4">
          <Select
            options={options}
            onChange={onStatusHandler}
            className="min-w-48 component_status"
          />
        </div>
      )}
    </div>
  );
};
